import { render, staticRenderFns } from "./Formas_Creacion_Formato.vue?vue&type=template&id=6172d77c&scoped=true"
import script from "./Formas_Creacion_Formato.vue?vue&type=script&lang=js"
export * from "./Formas_Creacion_Formato.vue?vue&type=script&lang=js"
import style0 from "./Formas_Creacion_Formato.vue?vue&type=style&index=0&id=6172d77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6172d77c",
  null
  
)

export default component.exports